import { BasicButton, BasicButtonProps, Spinner } from '.'
import { useFormikContext } from 'formik'

interface ButtonProps
  extends Pick<
    BasicButtonProps,
    'className' | 'fullWidth' | 'disabled' | 'translationId'
  > {
  checkIsDirty?: boolean
}

export interface FormikSubmitButtonProps {
  buttonProps?: ButtonProps
}

export const FormikSubmitButton = ({
  buttonProps
}: FormikSubmitButtonProps) => {
  const { isSubmitting, dirty } = useFormikContext()

  const checkIsDirty = buttonProps?.checkIsDirty ?? true

  const disabled =
    buttonProps?.disabled || isSubmitting || (checkIsDirty && !dirty)

  return (
    <BasicButton
      className={buttonProps?.className}
      disabled={disabled}
      fullWidth={buttonProps?.fullWidth}
      translationId={buttonProps?.translationId || 'common.saveChanges'}
      type="submit"
    >
      {isSubmitting && <Spinner size={16} sx={{ ml: 1 }} />}
    </BasicButton>
  )
}
